import { useEffect, useState } from "react";
import { Mail, Phone, Calendar, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PageHeader, StatusBadge, Select } from "@/components/admin/ui";

const STATUSES = ["new", "contacted", "scheduled", "archived"];

export default function Enquiries() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const load = () => api.get(`/admin/enquiries${filter ? `?status=${filter}` : ""}`).then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, [filter]);

  const setStatus = async (id, status) => { await api.put(`/admin/enquiries/${id}`, { status }); toast.success("Updated"); load(); };
  const del = async (id) => { if (!window.confirm("Delete enquiry?")) return; await api.delete(`/admin/enquiries/${id}`); toast.success("Deleted"); load(); };

  return (
    <div data-testid="admin-enquiries">
      <PageHeader title="Enquiries" subtitle="Appointment and contact enquiries from the website">
        <select value={filter} onChange={(e) => setFilter(e.target.value)} className="rounded-lg border border-stone-300 px-3 py-2 text-sm bg-white">
          <option value="">All</option>{STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </PageHeader>
      <div className="space-y-4">
        {items.length === 0 && <p className="text-center text-stone-400 py-16">No enquiries yet.</p>}
        {items.map((e) => (
          <div key={e.id} className="bg-white rounded-2xl border border-stone-200/80 p-6" data-testid={`enquiry-${e.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <div className="flex items-center gap-3 mb-1">
                  <h3 className="font-serif text-lg text-emerald-900">{e.first_name} {e.last_name}</h3>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${e.type === "appointment" ? "bg-emerald-100 text-emerald-700" : "bg-blue-100 text-blue-700"}`}>{e.type}</span>
                  <StatusBadge status={e.status} />
                </div>
                <div className="flex flex-wrap gap-4 text-xs text-stone-500 font-mono mb-3">
                  <a href={`mailto:${e.email}`} className="flex items-center gap-1 hover:text-emerald-700"><Mail size={12} /> {e.email}</a>
                  {e.phone && <a href={`tel:${e.phone}`} className="flex items-center gap-1 hover:text-emerald-700"><Phone size={12} /> {e.phone}</a>}
                  {e.preferred_date && <span className="flex items-center gap-1"><Calendar size={12} /> {e.preferred_date}</span>}
                  <span>{(e.created_at || "").slice(0, 16).replace("T", " ")}</span>
                </div>
                <p className="text-sm text-stone-700 whitespace-pre-wrap max-w-2xl">{e.message}</p>
              </div>
              <div className="flex items-center gap-2">
                <select value={e.status} onChange={(ev) => setStatus(e.id, ev.target.value)} data-testid={`enquiry-status-${e.id}`} className="rounded-lg border border-stone-300 px-3 py-1.5 text-sm bg-white">
                  {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
                <button onClick={() => del(e.id)} className="p-2 rounded-lg hover:bg-red-50 text-red-500"><Trash2 size={16} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
